export const NAVIGATE_TO_CAM_DASHBOARD_MOBILE = '/account/dashboard';
export const NAVIGATE_TO_CAM_DASHBOARD_DESKTOP = '/account/dashboard';
export const paymentMethodTypeIconMap = {
    'AMERICAN EXPRESS': 'american-express.svg',
    DISCOVER: 'discover.svg',
    AMEX: 'american-express.svg',
    'JCPENNEY MASTERCARD': 'jcpmastercard.svg',
    JCP: 'jcp-plcc.svg',
    'MASTER CARD': 'mastercard.svg',
    MASTERCARD: 'mastercard.svg',
    PAYPAL: 'paypal.svg',
    VISA: 'visa.svg',
    DUALCARD: 'jcpmastercard.svg',
    DEFAULT: 'neutral.svg',
};

export const ORDER_DETAILS_FETCH_CARD_TYPE_MAP = {
    AMEX: 'AMERICAN_EXPRESS',
    DISCOVER: 'DISCOVER',
    JCP: 'JCP_CARD',
    JCPMASTER: 'JCPENNY_MASTER_CARD',
    MASTER: 'MASTER_CARD',
    VISA: 'VISA',
};
export const ORDER_DETAILS_FETCH_EMAILABLE_CARE_PLAN_SUB_DIVISIONS = [
    '090',
    '117',
    '209',
    '683',
    '780',
    '864',
    '869',
    '076',
];
export const ORDER_DETAILS_FETCH_MAILABLE_CARE_PLAN_SUB_DIVISIONS = ['098'];
export const ORDER_DETAILS_FETCH_DELIVERY_PROMISE_MESSAGE_DESCRIPTION = {
    'Pickup Interval': 'Pickup: % s - % s',
    'Est Delivery Interval': 'Est.Delivery: % s - % s',
    'Est Delivery Date': 'Est.Delivery: % s',
    'Selected Delivery Date': 'Selected Delivery Date: % s',
    'Pickup Soon': 'THESE ITEMS WILL BE AVAILABLE FOR PICK UP IN 4 TO 7 BUSINESS DAYS.',
    'Email Care Plan': 'Care plan provider will email protection plan(s)',
    'Mail Protection Plan': 'Care plan provider will mail protection plan(s) to the address',
};
export const ORDER_DETAILS_FETCH_DELIVERY_PROMISE_STATUS = {
    Backordered: 'Backordered',
    Cancelled: 'Canceled',
    Delivered: 'Delivered',
    'In Process': 'In Progress',
    'In process': 'In Progress',
    'Transfer in Process': 'In Progress',
    'Pending fulfillment': 'In Progress',
    'Released to Fulfillment': 'In Progress',
    Picked: 'In Progress',
    Packed: 'In Progress',
    Shipped: 'Shipped',
    'Ready for Customer Pick': 'Ready for Pickup',
    'Picked by Customer': 'Picked Up',
    'Return Created': 'Returned',
    'Shipped to Store': 'Shipped to Store',
    'Post Invoice Cancel': 'Canceled',
    'Picked up Date': 'Picked Up: % s',
    'Picked up': 'Picked Up',
    'In Progress': 'In Progress',
    Returned: 'Returned',
    'Ready for Pickup': 'Ready for Pickup',
};
export const ORDER_DETAILS_FETCH_BACK_ORDER_ITEM_STATUS = ['Back Order', 'BO WOH', 'Backordered'];
export const ORDER_DETAILS_FETCH_CANCELLED_ITEM_STATUS = [
    'Back Order Cancel',
    'Canceled',
    'Cancelled',
];
export const ORDER_DETAILS_FETCH_NOT_AVAILABLE_ITEM_STATUS = [
    'Not Available',
    'Partial Available',
    'Partial Back Order',
    'Partial Discontinue',
    'Partial Track Order',
    'TO',
    'Discontinued',
    'No Process',
    'Dropped',
    'TO Recorder',
    'Back Order Delete',
    'Error',
];
export const ORDER_DETAILS_FETCH_FACTORY_SHIP_ITEM_STATUS = [
    'Factory Ship Supplier Cancel',
    'Factroy Ship Customer Cancel',
    'Factory Ship Release',
    'Factory Ship',
];
export const ORDER_DETAILS_FETCH_LARGE_APPLIANCE_ITEMS = [
    'largeAppliance',
    'LARGEAPPLIANCEINSTALL',
    'LARGEAPPLIANCESERVICE',
    'LARGEAPPLIANCEPARTS',
];
export const ORDER_DETAILS_FETCH_PROTECTION_PLAN_AND_SERVICE_ITEMS = [
    'SERVICE',
    'LARGEAPPLIANCEINSTALL',
    'LARGEAPPLIANCEPARTS',
];
export const ORDER_DETAILS_FETCH_PRICE_TYPES = [
    'PRICEQUOTE',
    'ORIGINAL',
    'ACTIVE',
    'CLEARANCE',
    'SALE',
    'FORCEDPRICE',
];
export const ORDER_DETAILS_FETCH_CHARGE_TYPES = [
    'TAX',
    'OVERSIZED SURCHARGE',
    'SHIPPING AND HANDLING',
    'GIFTWRAP',
    'RECYCLE CHARGE',
    'ROUND UP CHARITY',
];
export const ORDER_DETAILS_FETCH_DISCOUNT_TYPES = [
    'COUPON',
    'REWARDSCERT',
    'ENTERPRISE',
    'ASSOCIATEDISCOUNT',
    'SHIPPING',
    'MISCELLANEOUS',
];
export const ORDER_DETAILS_FETCH_ROUND_UP_CHARITY_LOT_NUMBERS = ['1712000'];
export const ORDER_DETAILS_FETCH_RECYCLE_FEE_LOT_NUMBERS = ['713'];
export const ORDER_DETAILS_FETCH_RETAIL_DELIVERY_FEE_LOT_NUMBERS = ['24601000018'];
export const navigateToSignIn = {
    mobile: '/signin',
    desktop: '/signin',
};
export const navigateToHome = {
    mobile: '/',
    desktop: '/',
};
export const CREATE_ACCOUNT_NUMBER_REG_EXP = /\d/;

export const CREATE_ACCOUNT_FIRST_NAME_REGX = /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{2})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{1,17}$/;
export const CREATE_ACCOUNT_LAST_NAME_REGX = /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{3})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{2,22}$/;
export const CREATE_ACCOUNT_INVALID_PHONE_NUMBER = 'Enter a valid phone number';
export const SIGNIN_EMPTY_EMAIL_ERROR_MESSAGE = 'Enter a valid email';
export const SIGNIN_LONG_EMAIL_ERROR_MESSAGE = 'Email should contain not more than 70 characters.';
export const PLACEHOLDER_NEW_PASSWORD = 'New Password';
export const termsAndConditionsLink =
    'http://www.jcpenney.com/m/rewards-terms-and-conditions?pageId=pg40067700009';
export const DP_USER_STATE = 'DP_USER_STATE';
export const DP_REWARDS_CERTS = 'DP_REWARDS_CERTS';
export const CONFIRM_NEW_MAIL = 'Email does not match';
export const confirmCreateAccount = {
    title: 'Confirm Your Account',
    message: 'A confirmation email has been sent to ',
    spamCheckMsg: 'Make sure to check your spam folder.',
};
export const keepMeLoggedIn = {
    title: 'Keep Me Signed In',
    helpMessage: 'Uncheck the box if this is a shared device.',
};
export const navigateToRewardsHome = {
    mobile: '/rewards',
    desktop: '/rewards',
};
export const trackOrder = {
    inputFields: {
        orderNumber: {
            defaultError: 'Enter a valid order number',
            label: 'Order Number',
            type: 'text',
            name: 'orderNumber',
            onlyNum: /[^\d]/g,
        },
        phoneNumber: {
            defaultError: 'Enter a valid phone number',
            label: 'Phone Number',
            placeholder: '( ___ ) ___ - ____ ',
            name: 'phoneNumber',
        },
    },
};

export const enableInputFieldMaskFix = ['phone', 'phoneNumber', 'creditCardNumber', 'email'];
// TODO: clean up 001, 013, 014, 015 after new UX changes go live
export const syfResponseCodes = {
    '000': { analyticsStatus: 'bannerimpression' },
    '001': { analyticsStatus: 'user-decline', CAMStatus: 'CUSTOMER_DECLINED' },
    '002': { analyticsStatus: 'display-offer' },
    '003': { analyticsStatus: 'close-modal' },
    '005': { analyticsStatus: 'ask-me-later' },
    '006': { analyticsStatus: 'user-not-me' },
    '010': { analyticsStatus: 'accepted', CAMStatus: 'SYF_ACCEPTED' },
    '011': { analyticsStatus: 'referred', CAMStatus: 'SYF_REFERRED' },
    '012': { analyticsStatus: 'declined', CAMStatus: 'SYF_DECLINED' },
    '013': { analyticsStatus: 'user-decline', CAMStatus: 'CUSTOMER_DECLINED' },
    '014': { analyticsStatus: 'user-not-me', CAMStatus: 'CUSTOMER_NOT_ME' },
    '015': { analyticsStatus: 'user-accept-offer' },
    '099': { analyticsStatus: 'system-error' },
    '016': { analyticsStatus: 'shopOnline' },
};

// Verify below codes once enableAppsSDKQSWidget enabled. Apps integration not yet done.
export const syfResponseCodeWebView = {
    'Decline-Offer': '001',
    'ask-me-later': '005',
    // 'user-not-me': '006',
    APPROVED: '010',
    REFERRED: '011',
    DECLINED: '012',
    'user-not-me': '014',
};
// TODO: clean up 001, 013, 014 after new QS UX changes go live
export const codesToHideBannerOnClose = ['001', '005', '010', '011', '012', '013', '014'];

export const quickScreenText = {
    preApproveText: `you're pre-approved!`,
    preApproveSeperateText: `You're pre-approved!`,
    offerMessage: 'Get 35% off',
    cardDescText: 'select purchases when you open and use a new',
    termsInfoText: 'See discount terms',
    jcpCreditCard: 'JCPenney Credit Card',
    jcpMasterCard: 'JCPenney Mastercard',
};
